import React from 'react';
import { ReactComponent as HistoryIcon } from '../assets/history.svg'
import { ReactComponent as HistoryDefaultIcon } from '../assets/history-default.svg'
import { ReactComponent as CheckIcon } from '../assets/check.svg'
import { ReactComponent as Select } from '../assets/select.svg'
import { ReactComponent as Selected } from '../assets/selected.svg'
import { formatarMoeda } from '../lib/utils';
type ThemeKey = 'default' | 'red' | 'green'

interface Props {
  onClick?: () => void;
  theme: ThemeKey;
  price: number;
  duedate: string;
  situacao?: string;
  nextInvoice?: string;
  selectable?: boolean;
  selected?: boolean;
  parcelas?: string;
  entrada?: boolean;
  quantidade?: number;
}

type ThemeValues = {
  font_color: string
}

const Invoice: React.FC<Props> = ({ duedate, nextInvoice, theme, price, parcelas, situacao, selectable, selected, onClick, quantidade, entrada }) => {

  const theme_model: Record<ThemeKey, ThemeValues> = {
    default: {
      font_color: "text-gray-dark"
    },
    red: {
      font_color: "text-red-primary"
    },
    green: {
      font_color: "text-green-dark"
    }
  }


  const formatDate = (dateStr: string) => {
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("pt-BR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <button
      className={`
        w-[100%]
        rounded-[0.75rem]
        flex flex-row
        items-center
        ${selectable && selected && 'border'}
        ${selectable && selected && 'border-gray-medium'}
        ${selectable && selected && 'bg-gray-back'}
        ${selectable && selected && 'py-[1.5rem] px-[0.8rem]'}
        ${selectable && 'px-[0.8rem]'} 
        py-[1.5rem] 
     `}
      onClick={onClick}
    >
      {selectable &&
        <div className='pr-[1.12rem]'>
          {selected ?
            <Selected className='w-[1.6rem] h-[1.6rem]' /> :
            <Select className='w-[1.6rem] h-[1.6rem]' />
          }
        </div>
      }
      <div>
        <div className='flex flex-row'>
          <p className={'text-gray-font'}>
            Vencimento dia
          </p>
          <strong className='ml-1'>
            {formatDate(duedate)}
          </strong>
        </div>
        <div className='flex flex-row items-center'>
          <p className={`${theme_model[theme].font_color} mr-1`}>R$</p>
          <strong className={`text-[1.6rem] font-[600] ${theme_model[theme].font_color}`}>
            {
            quantidade ? 
            formatarMoeda(parcelas && !entrada ? price * quantidade / parseInt(parcelas) : price * quantidade)
            : 
            formatarMoeda(parcelas && !entrada ? price / parseInt(parcelas) : price)
            }
          </strong>
        </div>
        {situacao &&
          <div className='flex flex-row mt-[0.5rem] items-center'>
            {theme === 'red' ?
              <HistoryIcon className='w-[1.2rem] h-[1.2rem]' /> :
              theme === 'default' ?
                <HistoryDefaultIcon className='w-[1.2rem] h-[1.2rem]' />
                :
                <CheckIcon className='w-[1.2rem] h-[1.2rem]' />
            }
            <p><strong className={`text-[0.9rem] ml-[0.5rem] ${theme_model[theme].font_color}`}>{situacao === "Atrasada" ? "Aguardando Pagamento" : situacao}</strong></p>
          </div>
        }
        {nextInvoice &&
          <div>
            <p className={`text-[0.7rem] mt-[0.5rem] text-gray-font text-left`}>Próxima fatura fechará dia {formatDate(nextInvoice)}</p>
          </div>
        }
      </div>
    </button >
  );
}

export default Invoice;
